"use client"

import { useEffect } from "react"
import { getTracker } from "../monitoring/openReply"


const OpenReplayProvider = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const tracker = getTracker()
      // Starts the OpenReplay session tracking
      tracker.start()
    }
  }, [])

  return null
}

export default OpenReplayProvider
